module.exports = __webpack_public_path__ + "img/level_one.e76520c3.png";